const guestCheckinPaths = {
  GUEST_CHECKIN: ({ checkinId, guestId, venueId }) =>
    `${checkinId}/checkin-info?venueId=${venueId}&guestId=${guestId}`,
  FORCE_CHECKOUT: ({ checkinId }) => `${checkinId}/force-checkout`,
  EXPORT_BILLING_STATEMENT: ({ checkinId }) => `${checkinId}/billing-statement`,
  SEARCH_GUEST_CHECKIN_EXPORT: "search/export",
};

export default guestCheckinPaths;
